import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Truck, Ship } from "lucide-react";

const quickLinks = [
  { label: "Accueil", path: "/" },
  { label: "À Propos", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Contact", path: "/contact" },
  { label: "Demander un devis", path: "/devis" },
];

const services = [
  { icon: <Truck size={14} />, label: "Transport Routier", path: "/services#transport-routier" },
  { icon: <Ship size={14} />, label: "Fret Maritime", path: "/services#fret-maritime" },
];

export default function Footer() {
  return (
    <footer className="bg-[#0e1c2e] border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center mb-5">
              <img
                src="/images/logo-pierre-affretement.png"
                alt="Pierre Affrètement"
                className="w-auto object-contain"
                style={{ mixBlendMode: "screen", height: "80px" }}
              />
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Commissionnaire de transport basé à Vichy France, spécialiste de l’organisation de transports de marchandises, du local à l’international.
            </p>
            <div className="flex items-center gap-2">
              <div className="h-1 w-8 bg-[#E8902A] rounded-full" />
              <span className="text-xs text-slate-500 font-heading tracking-widest uppercase">
                Depuis 2021
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm tracking-widest uppercase text-white mb-6">
              Navigation
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-[#E8902A] text-sm transition-colors duration-200 flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 bg-[#E8902A] rounded-full opacity-0 group-hover:opacity-100 transition-opacity" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm tracking-widest uppercase text-white mb-6">
              Nos Services
            </h4>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s.label} className="flex items-center gap-2 text-sm">
                  <span className="text-[#E8902A]">{s.icon}</span>
                  <Link
                    to={s.path}
                    className="text-slate-400 hover:text-[#E8902A] hover:underline transition-colors duration-200 cursor-pointer"
                    data-testid={`footer-service-${s.label.toLowerCase().replace(' ', '-')}`}
                  >
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm tracking-widest uppercase text-white mb-6">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-slate-400 text-sm">
                <MapPin size={16} className="text-[#E8902A] mt-0.5 flex-shrink-0" />
                <span>27 Avenue de Gramont<br />03200 Vichy, France</span>
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <Mail size={16} className="text-[#E8902A] flex-shrink-0" />
                <a
                  href="mailto:pierre@pierreaffretement.fr"
                  className="hover:text-[#E8902A] transition-colors"
                  data-testid="footer-email"
                >
                  pierre@pierreaffretement.fr
                </a>
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <Phone size={16} className="text-[#E8902A] flex-shrink-0" />
                <a href="tel:+33443500252" className="hover:text-[#E8902A] transition-colors" data-testid="footer-phone">
                  +33 (0)4 43 50 02 52
                </a>
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <Phone size={16} className="text-[#E8902A] flex-shrink-0 opacity-0" />
                <span>Lundi – Vendredi<br />8h30–12h | 14h–17h30</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-xs">
            © {new Date().getFullYear()} Pierre Affrètement. Tous droits réservés.
          </p>
          <p className="text-slate-600 text-xs">
            Commissionnaire de Transport — SIRET · 897 842 324 000 47 Cusset (03)
          </p>
        </div>
      </div>
    </footer>
  );
}
